import auTranslation from 'i18n/en-au/translation.json';
import enTranslation from 'i18n/en-us/translation.json';
import esTranslation from 'i18n/es-us/translation.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LOCALES } from 'utils/localisationConfig';

const resources = {
  [LOCALES.EN_US]: {
    translation: enTranslation,
  },
  [LOCALES.ES_US]: {
    translation: esTranslation,
  },
  [LOCALES.EN_AU]: {
    translation: auTranslation,
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: [LOCALES.EN_US],
  lowerCaseLng: true,
  fallbackLng: LOCALES.EN_US,
  debug: ['dev'].includes(process.env.GATSBY_ENV),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
